import { AdminDashboardServices } from "./service";

import {
  ADMIN_DASHBOARD_MENTOR_APPLICATION,
  ADMIN_DASHBOARD_MENTOR_REQUEST,
  VIEW_PREDEFINED_OPTIONS,
  GUIDED_INSTRUCTIONS,
  VIEW_COUNTER_OPTIONS,
  VIEW_COUNTER_SESSIONS,
  VIEW_COUNTER_STARTUP_OPTIONS,
  VIEW_COUNTER_HOURS,
  GET_NAMES_LIST,
  ADMIN_COHORT_APPLICATION_STATUS,
  COUNTER_COHORT_APPLICATION,
  ACTIVITY_SUMMARY_DASHBOARD,
  ACTIVITY_SUMMARY_PERFORMANCE,
  ACTIVITY_SUMMARY_NULL,
  ACTIVITY_SUMMARY_LOW_ACTIVITY,
  ACTIVITY_SUMMARY_MENTORSHIP_COUNT,
  ACTIVITY_SUMMARY_STARTUP_COUNT,
  ACTIVITY_SUMMARY_MENTORSHIP_TOTAL,
  ACTIVITY_SUMMARY_MENTORSHIP_STATUS,
  ACTIVITY_SUMMARY_COHORT_COUNT,
  EXPORT_EXCEL_COHORT,
  EXPORT_EXCEL_STARTUP,
  EXPORT_EXCEL_MENTOR,
  ADMIN_DASHBOARD_COHORT_GRAPH_DATA,
  ADMIN_DASHBOARD_MENTOR_GRAPH_DATA,
  COHORT_SPOTLIGHT_LIST,
  COHORT_SPOTLIGHT_CALENDAR,
  PUBLIC_GROUP_SESSIONS
} from "../../../../../common/constants/actionConstants";

import { isLoading } from "../../../../../common/dependencies/action/action";

export const getAdminMentorApplicationList = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindDataMentorAppList(params).then((data) => {
    const { getAdminMentorApplicationList } = data;
    if (getAdminMentorApplicationList) {
      dispatch({
        type: ADMIN_DASHBOARD_MENTOR_APPLICATION,
        payload: getAdminMentorApplicationList,
      });
    }
    dispatch(isLoading(false));
  });
};

export const getAdminMentorRequestList = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindDataMentorRequestList(params).then((data) => {
    const { getAdminMentorRequestList } = data;
    if (getAdminMentorRequestList) {
      dispatch({
        type: ADMIN_DASHBOARD_MENTOR_REQUEST,
        payload: getAdminMentorRequestList,
      });
    }
    dispatch(isLoading(false));
  });
};

export const openLoader = () => (dispatch) => {
  dispatch(isLoading(true));
};

export const closeLoader = () => (dispatch) => {
  dispatch(isLoading(false));
};

export const getPredefineOptionsList = (params) => (dispatch) => {
  if (!dispatch) {
    dispatch = params.dispatch;
  }
  dispatch(isLoading(true));
  return getBindDataPredefineList(params).then((data) => {
    const { getPredefineOptionsList } = data;
    if (getPredefineOptionsList) {
      dispatch({
        type: VIEW_PREDEFINED_OPTIONS,
        payload: getPredefineOptionsList,
      });
    }
    dispatch(isLoading(false));
  });
};
export const getStepperTooltipData = (params) => (dispatch) => {
  if (!dispatch) {
    dispatch = params.dispatch;
  }
  dispatch(isLoading(true));
  return getBindDataListStepper(params).then((data) => {
    const { getStepperTooltipData } = data;
    if (getStepperTooltipData) {
      dispatch({
        type: GUIDED_INSTRUCTIONS,
        payload: getStepperTooltipData,
      });
    }
    dispatch(isLoading(false));
  });
};
export const getCountersList = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindDataCounterList(params).then((data) => {
    const { getCountersList } = data;
    if (getCountersList) {
      dispatch({
        type: VIEW_COUNTER_OPTIONS,
        payload: getCountersList,
      });
    }
    dispatch(isLoading(false));
  });
};

export const getCountersSessions = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindDataCounterSessions(params).then((data) => {
    const { getCountersSessions } = data;
    if (getCountersSessions) {
      dispatch({
        type: VIEW_COUNTER_SESSIONS,
        payload: getCountersSessions,
      });
    }
    dispatch(isLoading(false));
  });
};
export const getCountersHours = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindDataCounterHours(params).then((data) => {
    const { getCountersHours } = data;
    if (getCountersHours) {
      dispatch({
        type: VIEW_COUNTER_HOURS,
        payload: getCountersHours,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindDataCounterHours(params) {
  const getCountersHours = await AdminDashboardServices.getCountersHours(
    params
  ).catch((e) => {
    return { data: [], status: false };
  });
  return {
    getCountersHours,
  };
}

async function getBindDataMentorAppList(params) {
  const getAdminMentorApplicationList =
    await AdminDashboardServices.getAdminMentorApplicationList(params).catch(
      (e) => {
        return { data: [], status: false };
      }
    );

  return {
    getAdminMentorApplicationList,
  };
}
async function getBindDataMentorRequestList(params) {
  const getAdminMentorRequestList =
    await AdminDashboardServices.getAdminMentorRequestList(params).catch(
      (e) => {
        return { data: [], status: false };
      }
    );

  return {
    getAdminMentorRequestList,
  };
}
async function getBindDataPredefineList(params) {
  const getPredefineOptionsList =
    await AdminDashboardServices.getPredefineOptionsList().catch((e) => {
      return { data: [], status: false };
    });

  return {
    getPredefineOptionsList,
  };
}
async function getBindDataListStepper(params) {
  const getStepperTooltipData =
    await AdminDashboardServices.getStepperList().catch((e) => {
      return { data: [], status: false };
    });

  return {
    getStepperTooltipData,
  };
}
async function getBindDataCounterList(params) {
  const getCountersList = await AdminDashboardServices.getCountersList().catch(
    (e) => {
      return { data: [], status: false };
    }
  );
  return {
    getCountersList,
  };
}

async function getBindDataCounterSessions(params) {
  const getCountersSessions =
    await AdminDashboardServices.getCountersSessions().catch((e) => {
      return { data: [], status: false };
    });
  return {
    getCountersSessions,
  };
}
export const getNamesList = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindDataNamesList(params).then((data) => {
    const { getNamesListData } = data;
    if (getNamesListData) {
      dispatch({
        type: GET_NAMES_LIST,
        payload: getNamesListData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindDataNamesList(params) {
  const getNamesListData = await AdminDashboardServices.getNamesAPI(
    params
  ).catch((e) => {
    return { data: [], status: false };
  });
  return {
    getNamesListData,
  };
}
export const destructNamesList = () => (dispatch) => {
  // dispatch(isLoading(true));
  // return getBindDataNamesList(params).then((data) => {
  // const { getNamesListData } = data;
  // if (getNamesListData) {
  dispatch({
    type: GET_NAMES_LIST,
    payload: undefined,
  });
  // }
  // dispatch(isLoading(false));
  // });
};
// async function getBindDestructNamesList(params) {
//   const getNamesListData = await AdminDashboardServices.getNamesAPI(params).catch(
//     (e) => {
//       return { data: [], status: false };
//     }
//   );
//   return {
//     getNamesListData,
//   };
// }

export const setAdminCohortAppStatus = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindsetAdminCohortStatus(params).then((data) => {
    const { getAdminCohortStatus } = data;
    if (getAdminCohortStatus) {
      dispatch({
        type: ADMIN_COHORT_APPLICATION_STATUS,
        payload: getAdminCohortStatus,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindsetAdminCohortStatus(params) {
  const getAdminCohortStatus =
    await AdminDashboardServices.setAdminCohortStatus(params).catch((e) => {
      return { data: [], status: false };
    });
  return {
    getAdminCohortStatus,
  };
}

export const getCohortApplicationCounter = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindCohortApplicationCounter(params).then((data) => {
    const { getCohortApplicationCounterData } = data;
    if (getCohortApplicationCounterData) {
      dispatch({
        type: COUNTER_COHORT_APPLICATION,
        payload: getCohortApplicationCounterData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindCohortApplicationCounter(params) {
  const getCohortApplicationCounterData =
    await AdminDashboardServices.getCohortApplicationCounterAPI(params).catch(
      (e) => {
        return { data: [], status: false };
      }
    );
  return {
    getCohortApplicationCounterData,
  };
}

export const getActivitySummaryDashboard = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindActivitySummaryDashboard(params).then((data) => {
    //
    const { getActivitySummaryDashboardData } = data;

    if (getActivitySummaryDashboardData) {
      dispatch({
        type: ACTIVITY_SUMMARY_DASHBOARD,
        payload: getActivitySummaryDashboardData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindActivitySummaryDashboard(params) {
  const getActivitySummaryDashboardData =
    await AdminDashboardServices.getActivitySummaryDashboardAPI(params).catch(
      (e) => {
        return { data: [], status: false };
      }
    );
  return {
    getActivitySummaryDashboardData,
  };
}

export const getActivitySummaryMentorshipStatus = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindActivitySummaryMentorshipStatus(params).then((data) => {
    //
    const { getActivitySummaryMentorshipStatusData } = data;

    if (getActivitySummaryMentorshipStatusData) {
      dispatch({
        type: ACTIVITY_SUMMARY_MENTORSHIP_STATUS,
        payload: getActivitySummaryMentorshipStatusData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindActivitySummaryMentorshipStatus(params) {
  const getActivitySummaryMentorshipStatusData =
    await AdminDashboardServices.getActivitySummaryMentorshipStatus(
      params
    ).catch((e) => {
      return { data: [], status: false };
    });
  return {
    getActivitySummaryMentorshipStatusData,
  };
}
export const getActivitySummaryMentorshipTotal = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindActivitySummaryMentorshipTotal(params).then((data) => {
    //
    const { getActivitySummaryMentorshipTotalData } = data;

    if (getActivitySummaryMentorshipTotalData) {
      dispatch({
        type: ACTIVITY_SUMMARY_MENTORSHIP_TOTAL,
        payload: getActivitySummaryMentorshipTotalData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindActivitySummaryMentorshipTotal(params) {
  const getActivitySummaryMentorshipTotalData =
    await AdminDashboardServices.getActivitySummaryStartupTotal(params).catch(
      (e) => {
        return { data: [], status: false };
      }
    );
  return {
    getActivitySummaryMentorshipTotalData,
  };
}
export const getActivitySummaryMentorshipCount = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindActivitySummaryMentorshipCount(params).then((data) => {
    //
    const { getActivitySummaryMentorshipCountData } = data;

    if (getActivitySummaryMentorshipCountData) {
      dispatch({
        type: ACTIVITY_SUMMARY_MENTORSHIP_COUNT,
        payload: getActivitySummaryMentorshipCountData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindActivitySummaryMentorshipCount(params) {
  const getActivitySummaryMentorshipCountData =
    await AdminDashboardServices.getActivitySummaryMentorshipCount(
      params
    ).catch((e) => {
      return { data: [], status: false };
    });
  return {
    getActivitySummaryMentorshipCountData,
  };
}
export const getActivitySummaryStartupCount = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindActivitySummaryStartupCount(params).then((data) => {
    //
    const { getActivitySummaryStartupCountData } = data;

    if (getActivitySummaryStartupCountData) {
      dispatch({
        type: ACTIVITY_SUMMARY_STARTUP_COUNT,
        payload: getActivitySummaryStartupCountData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindActivitySummaryStartupCount(params) {
  const getActivitySummaryStartupCountData =
    await AdminDashboardServices.getActivitySummaryStartupCount(params).catch(
      (e) => {
        return { data: [], status: false };
      }
    );
  return {
    getActivitySummaryStartupCountData,
  };
}
export const getActivitySummaryCohortCount = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindActivitySummaryCohortCount(params).then((data) => {
    //
    const { getActivitySummaryCohortCountData } = data;

    if (getActivitySummaryCohortCountData) {
      dispatch({
        type: ACTIVITY_SUMMARY_COHORT_COUNT,
        payload: getActivitySummaryCohortCountData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindActivitySummaryCohortCount(params) {
  const getActivitySummaryCohortCountData =
    await AdminDashboardServices.getActivitySummaryCohortCount(params).catch(
      (e) => {
        return { data: [], status: false };
      }
    );
  return {
    getActivitySummaryCohortCountData,
  };
}

export const getActivitySummaryPerformance = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindActivitySummaryPerformance(params).then((data) => {
    //
    const { getActivitySummaryPerformanceData } = data;

    if (getActivitySummaryPerformanceData) {
      dispatch({
        type: ACTIVITY_SUMMARY_PERFORMANCE,
        payload: getActivitySummaryPerformanceData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindActivitySummaryPerformance(params) {
  const getActivitySummaryPerformanceData =
    await AdminDashboardServices.getActivitySummaryPerformanceAPI(params).catch(
      (e) => {
        return { data: [], status: false };
      }
    );
  return {
    getActivitySummaryPerformanceData,
  };
}
export const getActivitySummaryNull = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindActivitySummaryNull(params).then((data) => {
    //
    const { getBindActivitySummaryNullData } = data;

    if (getBindActivitySummaryNullData) {
      dispatch({
        type: ACTIVITY_SUMMARY_NULL,
        payload: getBindActivitySummaryNullData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindActivitySummaryNull(params) {
  const getBindActivitySummaryNullData =
    await AdminDashboardServices.getActivitySummaryNullAPI(params).catch(
      (e) => {
        return { data: [], status: false };
      }
    );
  return {
    getBindActivitySummaryNullData,
  };
}
export const getActivitySummaryLowInteraction = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindActivitySummaryLowInteraction(params).then((data) => {
    //
    const { getBindActivitySummaryLowInteractionData } = data;

    if (getBindActivitySummaryLowInteractionData) {
      dispatch({
        type: ACTIVITY_SUMMARY_LOW_ACTIVITY,
        payload: getBindActivitySummaryLowInteractionData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindActivitySummaryLowInteraction(params) {
  const getBindActivitySummaryLowInteractionData =
    await AdminDashboardServices.getActivitySummaryLowActivityAPI(params).catch(
      (e) => {
        return { data: [], status: false };
      }
    );
  return {
    getBindActivitySummaryLowInteractionData,
  };
}
export const getExcelMentor = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindExcelMentor(params).then((data) => {
    //
    const { getBindExcelMentorData } = data;

    if (getBindExcelMentorData) {
      dispatch({
        type: EXPORT_EXCEL_MENTOR,
        payload: getBindExcelMentorData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindExcelMentor(params) {
  const getBindExcelMentorData = await AdminDashboardServices.getExcelMentor(
    params
  ).catch((e) => {
    return { data: [], status: false };
  });
  return {
    getBindExcelMentorData,
  };
}

export const getExcelStartup = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindExcelStartup(params).then((data) => {
    //
    const { getBindExcelStartupData } = data;

    if (getBindExcelStartupData) {
      dispatch({
        type: EXPORT_EXCEL_STARTUP,
        payload: getBindExcelStartupData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindExcelStartup(params) {
  const getBindExcelStartupData = await AdminDashboardServices.getExcelStartup(
    params
  ).catch((e) => {
    return { data: [], status: false };
  });
  return {
    getBindExcelStartupData,
  };
}

export const getExcelCohort = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindExcelCohort(params).then((data) => {
    //
    const { getBindExcelCohortData } = data;

    if (getBindExcelCohortData) {
      dispatch({
        type: EXPORT_EXCEL_COHORT,
        payload: getBindExcelCohortData,
      });
    }
    dispatch(isLoading(false));
  });
};
async function getBindExcelCohort(params) {
  const getBindExcelCohortData = await AdminDashboardServices.getExcelCohort(
    params
  ).catch((e) => {
    return { data: [], status: false };
  });
  return {
    getBindExcelCohortData,
  };
}

export const getAdminDashCohortGraphData = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindAdminDashCohortGraphData(params).then((data) => {
    const { getBindAdminDashCohortGraphData } = data;
    if (getBindAdminDashCohortGraphData) {
      dispatch({
        type: ADMIN_DASHBOARD_COHORT_GRAPH_DATA,
        payload: getBindAdminDashCohortGraphData,
      });
    }
    dispatch(isLoading(false));
  });
};

async function getBindAdminDashCohortGraphData(params) {
  const getBindAdminDashCohortGraphData =
    await AdminDashboardServices.adminDashCohortCounterAPI(params).catch(
      (e) => {
        return { data: [], status: false };
      }
    );

  return {
    getBindAdminDashCohortGraphData,
  };
}
export const getCohortPublicData = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindCohortPublicData(params).then((data) => {
    const { getBindCohortData } = data;
    if (getBindCohortData) {
      dispatch({
        type: PUBLIC_GROUP_SESSIONS,
        payload: getBindCohortData,
      });
    }
    dispatch(isLoading(false));
  });
};

async function getBindCohortPublicData(params) {
  const getBindCohortData =
    await AdminDashboardServices.publicCohortListData(params).catch(
      (e) => {
        return { data: [], status: false };
      }
    );

  return {
    getBindCohortData,
  };
}
export const getAdminDashMentorGraphData = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return getBindAdminDashMentorGraphData(params).then((data) => {
    const { getBindAdminDashMentorGraphData } = data;
    if (getBindAdminDashMentorGraphData) {
      dispatch({
        type: ADMIN_DASHBOARD_MENTOR_GRAPH_DATA,
        payload: getBindAdminDashMentorGraphData,
      });
    }
    dispatch(isLoading(false));
  });
};

async function getBindAdminDashMentorGraphData(params) {
  const getBindAdminDashMentorGraphData =
    await AdminDashboardServices.adminDashMentorCounterAPI(params).catch(
      (e) => {
        return { data: [], status: false };
      }
    );

  return {
    getBindAdminDashMentorGraphData,
  };
}
export const getAdminDashSpotLightData = (params) => (dispatch) => {
  return getBindAdminDashSpotLightData(params).then((data) => {
    const { getBindAdminDashSpotLightData } = data;
    if (getBindAdminDashSpotLightData) {
      dispatch({
        type: COHORT_SPOTLIGHT_LIST,
        payload: getBindAdminDashSpotLightData,
      });
    }
  });
};

async function getBindAdminDashSpotLightData(params) {
  const getBindAdminDashSpotLightData =
    await AdminDashboardServices.getSpotLightList(params).catch(
      (e) => {
        return { data: [], status: false };
      }
    );

  return {
    getBindAdminDashSpotLightData,
  };
}
export const getAdminDashSpotLightCalendarData = (params) => (dispatch) => {
  return getBindAdminDashSpotLightCalendarData(params).then((data) => {
    const { getBindAdminDashSpotLightCalendarData } = data;
    if (getBindAdminDashSpotLightCalendarData) {
      dispatch({
        type: COHORT_SPOTLIGHT_CALENDAR,
        payload: getBindAdminDashSpotLightCalendarData,
      });
    }
  });
};

async function getBindAdminDashSpotLightCalendarData(params) {
  const getBindAdminDashSpotLightCalendarData =
    await AdminDashboardServices.getSpotLightList(params).catch(
      (e) => {
        return { data: [], status: false };
      }
    );

  return {
    getBindAdminDashSpotLightCalendarData,
  };
}